

























































import Vue from 'vue';
import {Icon} from "@/helpers/icons";
import {AxiosError} from "axios";
import {Component} from "vue-property-decorator";
import AsiCard from "@/components/common/AsiCard.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiFormErrors from "@/components/common/AsiFormErrors.vue";
import LoginRequest from "@/models/auth/LoginRequest";
import TokenResult from "@/models/auth/TokenResult";
import RequiredValidator from "@/validators/RequiredValidator";
import AsiAlert from "@/components/common/AsiAlert.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiBtn from "@/components/common/AsiBtn.vue";

@Component({
	components: {AsiBtn, AsiContentContainer, AsiAlert, AsiCard, AsiTextField, AsiFormErrors},
})
export default class AsiLoginForm extends Vue {

	private icons = Icon;
	private loading = false;
	private showPassword = false;
	private valid = true;
	private forgotPasswordMode = false;
	private email = '';
	private password = '';
	private emailRules = [
		(new RequiredValidator('user.username')).validationRule(),
	];
	private passwordRules = [
		(new RequiredValidator('user.password')).validationRule(),
	];
	private errors = [] as string[];
	private success = null as string | null;

	private performLogin(): void {
		this.loading = true;
		this.$authService.login(LoginRequest.InstanceFromLogin(this.email, this.password))
			.then((tokenResult: TokenResult) => {
				this.$store.commit('user/setTokens', tokenResult);
				this.$store.dispatch('user/loadLoggedInUserData');

				if (this.$route.name !== 'Home') {
					this.$router.push({name: 'Home'});
				}
			})
			.catch((err: AxiosError) => {
				this.errors = err.response?.data
			})
			.finally(() => this.loading = false);
	}

	private performForgotPassword(): void {
		this.loading = true;
		this.$authService.resetPassword(this.email)
			.then(() => {
				this.success = this.$t('uiTerms.passwordReset').toString();
				this.errors = [];
			})
			.catch(() => {
				this.errors = [this.$t('error.clientSide').toString()]
				this.success = null;
			})
			.finally(() => this.loading = false);
	}
}
